export default "__VITE_ASSET__BXtgJ_Zu__"